import { getEnvironmentVariable } from 'utils/env'

export const UNI_LIST = 'https://tokens.uniswap.org'
export const UNI_EXTENDED_LIST = 'https://extendedtokens.uniswap.org/'
const UNI_UNSUPPORTED_LIST = 'https://unsupportedtokens.uniswap.org/'
// const AAVE_LIST = 'tokenlist.aave.eth'
const BA_LIST = 'https://raw.githubusercontent.com/The-Blockchain-Association/sec-notice-list/master/ba-sec-list.json'
// const CMC_ALL_LIST = 'https://api.coinmarketcap.com/data-api/v3/uniswap/all.json'
// const COINGECKO_LIST = 'https://tokens.coingecko.com/uniswap/all.json'
// const COMPOUND_LIST = 'https://raw.githubusercontent.com/compound-finance/token-list/master/compound.tokenlist.json'
// const GEMINI_LIST = 'https://www.gemini.com/uniswap/manifest.json'
// const KLEROS_LIST = 't2crtokens.eth'
// const SET_LIST = 'https://raw.githubusercontent.com/SetProtocol/uniswap-tokenlist/main/set.tokenlist.json'
// const WRAPPED_LIST = 'wrapped.tokensoft.eth'

// SAMVI Info: List and URL for Tokens on Hydra
export const MAINNET_HYDRASWAP_LIST = getEnvironmentVariable('REACT_APP_MAINNET_HYDRASWAP_TOKEN_LIST')
export const TESTNET_HYDRASWAP_LIST = getEnvironmentVariable('REACT_APP_TESTNET_HYDRASWAP_TOKEN_LIST')
export const DEVNET_HYDRASWAP_LIST = getEnvironmentVariable('REACT_APP_DEVNET_HYDRASWAP_TOKEN_LIST')

export const UNSUPPORTED_LIST_URLS: string[] = [BA_LIST, UNI_UNSUPPORTED_LIST]

const IS_DEV = getEnvironmentVariable('REACT_APP_ENV') === 'dev'

// default lists to be 'active' aka searched across
// --- search for default active list and replace
export const DEFAULT_ACTIVE_LIST_URLS: string[] = IS_DEV
  ? [TESTNET_HYDRASWAP_LIST, DEVNET_HYDRASWAP_LIST]
  : [MAINNET_HYDRASWAP_LIST]

export const DEFAULT_INACTIVE_LIST_URLS: string[] = IS_DEV
  ? [MAINNET_HYDRASWAP_LIST]
  : [TESTNET_HYDRASWAP_LIST, DEVNET_HYDRASWAP_LIST]

export const DEFAULT_LIST_OF_LISTS: string[] = [...DEFAULT_ACTIVE_LIST_URLS, ...DEFAULT_INACTIVE_LIST_URLS]
